<template>
  <svg class="compass" viewBox="0 0 200 200" width="170" height="170" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="compass-face" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="currentColor" stop-opacity="0.04" />
        <stop offset="100%" stop-color="currentColor" stop-opacity="0.14" />
      </radialGradient>
      <filter id="compass-shadow" x="-30%" y="-30%" width="160%" height="160%">
        <feDropShadow dx="0" dy="2" stdDeviation="2" flood-opacity="0.35" />
      </filter>
    </defs>

    <!-- Face -->
    <circle cx="100" cy="100" r="92" fill="url(#compass-face)" stroke="currentColor" stroke-opacity="0.45" stroke-width="2" />
    <circle cx="100" cy="100" r="68" fill="none" stroke="currentColor" stroke-opacity="0.2" stroke-width="1" />

    <!-- Ticks every 10°, longer every 30° -->
    <g stroke="currentColor">
      <line v-for="t in ticks" :key="t.a" x1="100" :y1="t.major ? 10 : 10" x2="100" :y2="t.major ? 22 : 16"
            :stroke-width="t.major ? 2 : 1" :stroke-opacity="t.major ? 0.8 : 0.4"
            :transform="`rotate(${t.a} 100 100)`" />
    </g>

    <!-- Intercardinal star -->
    <g fill="currentColor" fill-opacity="0.18">
      <polygon points="100,38 106,94 100,100 94,94" transform="rotate(45 100 100)" />
      <polygon points="100,38 106,94 100,100 94,94" transform="rotate(135 100 100)" />
      <polygon points="100,38 106,94 100,100 94,94" transform="rotate(225 100 100)" />
      <polygon points="100,38 106,94 100,100 94,94" transform="rotate(315 100 100)" />
    </g>
    <!-- Cardinal star -->
    <g fill="currentColor" fill-opacity="0.35">
      <polygon points="100,28 107,93 100,100 93,93" />
      <polygon points="100,28 107,93 100,100 93,93" transform="rotate(90 100 100)" />
      <polygon points="100,28 107,93 100,100 93,93" transform="rotate(180 100 100)" />
      <polygon points="100,28 107,93 100,100 93,93" transform="rotate(270 100 100)" />
    </g>

    <!-- Letters -->
    <g font-size="15" font-weight="bold" text-anchor="middle" fill="currentColor">
      <text x="100" y="45">N</text>
      <text x="162" y="105">O</text>
      <text x="100" y="164">S</text>
      <text x="38" y="105">W</text>
    </g>

    <!-- Wind arrow (points where the wind blows to), animated -->
    <g class="needle" :style="`transform: rotate(${angle}deg);`">
      <g filter="url(#compass-shadow)">
        <polygon points="100,22 114,104 100,94 86,104" fill="#e53935" />
        <polygon points="100,22 100,94 86,104" fill="#fff" fill-opacity="0.25" />
      </g>
    </g>

    <!-- Hub -->
    <circle cx="100" cy="100" r="15" fill="#fff" stroke="#e53935" stroke-width="3" />
    <text x="100" y="105" font-size="13" font-weight="bold" text-anchor="middle" fill="#333">{{wind_dirtext}}</text>
  </svg>
</template>

<script>
export default {
  name: 'AppCompass',
  props: {
    wind_dirtext: String,
    degrees: {
      type: Number,
      required: true,
      default: 0,
    }
  },
  data() {
    return {
      // accumulated angle, so the needle always turns the short way (350° -> 10° = +20°)
      angle: this.normalize(this.degrees),
    }
  },
  computed: {
    ticks() {
      return Array.from({ length: 36 }, (_, i) => ({ a: i * 10, major: i % 3 === 0 }))
    }
  },
  watch: {
    degrees(next) {
      const target = this.normalize(next)
      let diff = (target - this.angle) % 360
      if (diff > 180) diff -= 360
      if (diff < -180) diff += 360
      this.angle += diff
    }
  },
  methods: {
    normalize(d) {
      return Number.isFinite(d) ? d : 0
    }
  }
}
</script>

<style scoped>
.compass {
  display: block;
  margin: 0 auto;
}

.needle {
  transform-origin: 100px 100px;
  transition: transform 1.2s cubic-bezier(0.34, 1.3, 0.5, 1);
}
</style>
